import { qs } from '@/lib/api';

export function payBillPath(invoiceId: string, returnTo = '/appointments?view=list'): string {
  return `/billing/invoices/${invoiceId}${qs({ collect: 1, returnTo })}`;
}
